"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveTeamOrMembersByCsvDTO = exports.MoveTeamOrMemberDto = exports.UserTeamFutureSeasons = exports.JoinTeamDto = exports.JoinSuccessResponseDto = exports.CustomerJoinTeam = exports.GetInviteDto = exports.TeamByIdDto = exports.CreateInviteToTeamDto = exports.InviteeDto = exports.SaveUserAsGroupCaptain = exports.MoveUserInGroups = exports.ConnectGroupToDivision = exports.CreateGroupDto = exports.CreateDivisionDto = exports.CreateBulkDivisionsDto = exports.FindByProgramSeasonIdDto = void 0;
class FindByProgramSeasonIdDto {
}
exports.FindByProgramSeasonIdDto = FindByProgramSeasonIdDto;
class CreateBulkDivisionsDto {
}
exports.CreateBulkDivisionsDto = CreateBulkDivisionsDto;
class CreateDivisionDto {
}
exports.CreateDivisionDto = CreateDivisionDto;
class CreateGroupDto {
}
exports.CreateGroupDto = CreateGroupDto;
class ConnectGroupToDivision {
}
exports.ConnectGroupToDivision = ConnectGroupToDivision;
class MoveUserInGroups {
}
exports.MoveUserInGroups = MoveUserInGroups;
class SaveUserAsGroupCaptain {
}
exports.SaveUserAsGroupCaptain = SaveUserAsGroupCaptain;
class InviteeDto {
}
exports.InviteeDto = InviteeDto;
class CreateInviteToTeamDto {
}
exports.CreateInviteToTeamDto = CreateInviteToTeamDto;
class TeamByIdDto {
}
exports.TeamByIdDto = TeamByIdDto;
class GetInviteDto extends TeamByIdDto {
}
exports.GetInviteDto = GetInviteDto;
class CustomerJoinTeam {
}
exports.CustomerJoinTeam = CustomerJoinTeam;
class JoinSuccessResponseDto {
}
exports.JoinSuccessResponseDto = JoinSuccessResponseDto;
class JoinTeamDto {
}
exports.JoinTeamDto = JoinTeamDto;
class UserTeamFutureSeasons extends TeamByIdDto {
}
exports.UserTeamFutureSeasons = UserTeamFutureSeasons;
class MoveTeamOrMemberDto {
}
exports.MoveTeamOrMemberDto = MoveTeamOrMemberDto;
class MoveTeamOrMembersByCsvDTO {
}
exports.MoveTeamOrMembersByCsvDTO = MoveTeamOrMembersByCsvDTO;
//# sourceMappingURL=groupsDivisions.dto.js.map